import { authService, authHeaders } from '../../services/auth'
import {
  REGISTER_SUCCESS, REGISTER_FAILURE,
  LOGOUT_SUCCESS, LOGOUT_FAILURE,
  LOGIN_SUCCESS, LOGIN_FAILURE,
  SET_USER, TOKEN_INVALID,
  USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE,
  FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE,
} from '../mutation-types'
import router from '../../router'

const logout = (state) => {
  state.id = null;
  state.email = null;
  state.firstName = null;
  state.lastName = null;
  state.role = null;
  state.errors = null;
  state.showSuccess = false;
  state.loggedIn = false;
  authHeaders.forEach((key) => {
    localStorage.removeItem(key)
  })
  router.push('/login')
}

const state = {
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  role: null,
  errors: null,
  loggedIn: false,
  studySort: null,
  sortOrder: null,
  AllowSharing: true,
  notifications: true,
  showSuccess: false,
}

const getters = {}

const actions = {
  // Run once on page load and whenever you want to check token validity
  validateToken(context) {
    // console.log('validating token...')
    return authService.validateToken().then((user) => {
      context.commit(SET_USER, {user});
      return Promise.resolve(user);
    }, () => {
      context.commit(TOKEN_INVALID);
      return Promise.reject();
    });
  },

  //context has {commit, state, getters}
  register(context, payload) {
    authService.register(payload).then((newUser) => {
      authService.login(payload).then((user) => {
        context.commit(LOGIN_SUCCESS, { user });
        context.commit(REGISTER_SUCCESS, { user: newUser });
      }, (errors) => {
        context.commit(LOGIN_FAILURE, { errors });
      })
    }, (errors) => {
      context.commit(REGISTER_FAILURE, {errors});
    })
  },

  login(context, payload) {
    authService.login(payload.user).then((user) => {
      context.commit(LOGIN_SUCCESS, {user});
    }, (errors) => {
      context.commit(LOGIN_FAILURE, {errors});
    })

  },

  logout(context) {
    authService.logout().then(() => {
      context.commit(`LOGOUT_SUCCESS`);
      context.commit(`studier/LOGOUT_SUCCESS`);
    }, () => {
      context.commit(LOGOUT_FAILURE);
    })
  },


  updateUser(context, payload) {
    authService.update(payload.changes).then((user) => {
      context.commit(USER_UPDATE_SUCCESS, { user });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (errors) => {
      context.commit(USER_UPDATE_FAILURE, { errors });
      if (_.isFunction(payload.callback)) payload.callback(errors);
    })
  },

  forgotPassword(context, payload) {
    authService.forgotPassword(payload.credentials).then((result) => {
      context.commit(FORGOT_PASSWORD_SUCCESS, { result });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (errors) => {
      context.commit(FORGOT_PASSWORD_FAILURE, { errors });
      if (_.isFunction(payload.callback)) payload.callback(errors);
    })
  },

  resetPassword(context, payload) {
    authService.resetPassword(payload).then((result) => {
      context.commit(RESET_PASSWORD_SUCCESS, { result });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (errors) => {
      context.commit(RESET_PASSWORD_FAILURE, { errors });
      if (_.isFunction(payload.callback)) payload.callback(errors);
    })
  },
}


const mutations = {
  [REGISTER_SUCCESS] (state, payload) {
    state.id = payload.user.id;
    state.email = payload.user.email;
    state.firstName = payload.user.first_name;
    state.lastName = payload.user.last_name;
    state.role = payload.user.role;
    state.loggedIn = true;
    state.errors = null;
    state.studySort = payload.user.studySort;
    state.sortOrder = payload.user.sortOrder;
    state.role = payload.user.role;
    state.AllowSharing = payload.user.AllowSharing;
    state.notifications = payload.user.notifications;

    state.showSuccess = true;
    router.push('/signup-success')
  },

  [REGISTER_FAILURE] (state, payload) {
    state.id = false;
    state.email = false;
    state.firstName = null;
    state.lastName = null;
    state.role = null;
    state.loggedIn = false;
    state.errors = payload.errors;
    state.showSuccess = false;
  },

  [LOGOUT_SUCCESS] (state) {
    logout(state)
  },

  [LOGOUT_FAILURE] (state) {
    logout(state)
  },

  [TOKEN_INVALID] (state) {
    // Not sure if we should logout the user, or just go to login page?
    // logout(state)
    router.push('/login')
  },

  [LOGIN_SUCCESS](state, payload) {
    state.id = payload.user.id;
    state.email = payload.user.email;
    state.firstName = payload.user.first_name;
    state.lastName = payload.user.last_name;
    state.role = payload.user.role;
    state.loggedIn = true;
    state.errors = null;
    state.showSuccess = false;
    state.studySort = payload.user.studySort;
    state.sortOrder = payload.user.sortOrder;
    state.role = payload.user.role;
    state.AllowSharing = payload.user.AllowSharing;
    state.notifications = payload.user.notifications;
    router.push(payload.redirect || '/subject-shelf');
  },

  [LOGIN_FAILURE] (state, payload) {
    state.id = false;
    state.email = false;
    state.firstName = null;
    state.lastName = null;
    state.role = null;
    state.loggedIn = false;
    state.errors = payload.errors;
    state.showSuccess = false;
    router.push('/login')
  },

  [SET_USER](state, payload) {
    state.id = payload.user.id;
    state.email = payload.user.email;
    state.firstName = payload.user.first_name;
    state.lastName = payload.user.last_name;
    state.studySort = payload.user.studySort;
    state.sortOrder = payload.user.sortOrder;
    state.role = payload.user.role;
    state.AllowSharing = payload.user.AllowSharing;
    state.notifications = payload.user.notifications;
    state.loggedIn = true;
    state.errors = null;
    state.showSuccess = false;
  },

  [USER_UPDATE_SUCCESS](state, payload) {
    state.errors = null;
    state.email = payload.user.email;
    state.firstName = payload.user.first_name;
    state.lastName = payload.user.last_name;
    state.studySort = payload.user.studySort;
    state.sortOrder = payload.user.sortOrder;
    state.AllowSharing = payload.user.AllowSharing;
    state.notifications = payload.user.notifications;
    state.role = payload.user.role;
    state.showSuccess = true;
  },

  [USER_UPDATE_FAILURE](state, payload) {
    state.errors = payload.errors;
    state.showSuccess = false;
  },

  [FORGOT_PASSWORD_SUCCESS](state, payload) {
    Toast.success('Success! Please check your emails.');
  },

  [FORGOT_PASSWORD_FAILURE](state, payload) {
    state.errors = payload.errors;
    state.showSuccess = false;
  },

  [RESET_PASSWORD_SUCCESS](state, payload) {
    Toast.success('Password reset successful.');
    router.push('/login');
  },

  [RESET_PASSWORD_FAILURE](state, payload) {
    state.errors = payload.errors;
    state.showSuccess = false;
  },

  CLEAR_USER_ERRORS(state, payload) {
    state.errors = null;
    state.showSuccess = false;
  }
}



export default {
  state,
  getters,
  actions,
  mutations
}





// WEBPACK FOOTER //
// ./src/store/modules/user.js